/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 同乗者区分
 */
export type BaseInfoAccompanyingEnum =
  (typeof BaseInfoAccompanyingEnum)[keyof typeof BaseInfoAccompanyingEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoAccompanyingEnum = {
  RELATIVE: 'RELATIVE',
  COLLEAGUE: 'COLLEAGUE',
  FAMILY: 'FAMILY',
  DOCTOR: 'DOCTOR',
  NURSE: 'NURSE',
  ACQUAINTANCE: 'ACQUAINTANCE',
  POLICEMAN: 'POLICEMAN',
  EMS_TEAM: 'EMS_TEAM',
  FIREFIGHTING_TEAM: 'FIREFIGHTING_TEAM',
  PUBLIC_HEALTH_NURSE: 'PUBLIC_HEALTH_NURSE',
  MIDWIFE: 'MIDWIFE',
  HELPER: 'HELPER',
  FACILITY_STAFF: 'FACILITY_STAFF',
  TEACHER: 'TEACHER',
  PASSERBY: 'PASSERBY',
  FIRE_BRIGADE_MEMBER: 'FIRE_BRIGADE_MEMBER',
  OTHER: 'OTHER',
} as const;
